<template>
    <div class="templete">
        <div class="tabs">
            <div class="item" :class="{ 'active' : current == 0 } " @click="current = 0">北美材</div>
            <div class="item" :class="{ 'active' : current == 1 } " @click="current = 1">非洲材</div>
        </div>
        <div class="">
            <america-label v-show="current == 0"></america-label>
            <africa-label v-show="current == 1"></africa-label>
        </div>
    </div>
</template>
<style scoped lang="scss">
    .container{
        padding: 15px; display: flex; flex-direction: column; align-items: stretch; text-align: left; height: 100%; background-color: #fff; border-top:8px solid #EEEFF2; border-left:12px solid #EEEFF2; overflow: auto;
    }
    .templete{overflow: auto;}
    .tabs{
        display: flex; align-items: center; margin-bottom: 23px;
        .item {border-radius: 3px;
            font-size:14px; color: #333333; cursor: pointer; border: 1px solid #333333; padding: 5px 15px;
            &.active{ border: 1px solid #B21111;background-color: #B21111;color:#fff;}
        }
        .item + .item{ margin-left: 30px; }
    }
    .tab_content{ flex: 1; display: flex; flex-direction: column; height: 100%; overflow: hidden; }
</style>
<script>
import americaLabel from './americaLabel'
import africaLabel from './africaLabel'
    export default {
        components:{
            americaLabel,
            africaLabel
        },
        data(){
            return{
                current : 0,
            }
        }
    }
</script>
